<template>
  <div class="edit_container" style="min-height: 220px;">
    <quill-editor
      v-model="content"
      ref="myQuillEditor"
      :options="editorOption"
      @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
      @change="onEditorChange($event)">
    </quill-editor>
  </div>
</template>

<script>
    import {quillRedefine} from 'vue-quill-editor-upload'//引入图片上传
    export default {
        name: "articleEdit",
        props: ["parentContent"],
        data() {
            return {
                uploadUrl: this.env.env.uploadUrl,//文件上传接口
                content: `<br/><br/><br/><br/><br/>`,
                editorOption: {}
            }
        },
        created() {
            this.content = this.parentContent;
            this.editorOption = quillRedefine({ //修改富文本编辑器图片上传路径
                // 图片上传的设置
                uploadConfig: {
                    action: this.uploadUrl,  // 必填参数 图片上传地址
                    res: (respnse) => {
                        console.log(respnse)
                        return respnse.data;//return图片url
                    },
                    name: 'file'  // 图片上传参数名
                }
            })
            this.editorOption ={
                ...this.editorOption,
                placeholder :'请输入内容'
            }
        },
        methods: {
            show(content) {
            },
            onEditorReady(editor) {
                // 准备编辑器
            },
            onEditorBlur() {
                // 失去焦点事件
            },
            onEditorFocus() {
                // 获得焦点事件
            },
            onEditorChange(event) {
                // 内容改变事件
                this.$emit("listenToChildEvent", this.content)
            },
        },
        compued: {
            editor() {
                return this.$refs.myQuillEditor.quill;
            },
        },
        watch: {
            parentContent(newVal, oldVal) {
                this.content = newVal;
            }
        }
    }
</script>

<style scoped>
  .quill-editor{
    /*min-height:120px;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/plugins/edit/articleEdit.vue